import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'
import gsap from 'gsap'

//* Components
import CustomLink from 'components/common/CustomLink'
import Text from 'components/common/Text'
import AnimationWrap from 'components/common/AnimationWrap'

//* Style
import MenuItemsStyle from './style'

//* helpers
import config from 'helpers/_config'
import { withUIContext } from 'context'

const MenuItems = ({ type, closeBurgerMenu, winWidth, className }) => {
	//! router
	const router = useRouter()

	//! States
	const [secObj, setSecObj] = useState()

	//! Refs
	const items = useRef([])
	const itemsRef = useRef([])

	useEffect(() => {
		if (items?.current) {
			setSecObj([items.current])
		}
	}, [items, router.pathname, winWidth])

	const startAnimeArr = useCallback((x) => {
		if (x && type === 'footer') {
			const itemsArr = [itemsRef.current]

			gsap.set(itemsArr, {
				y: '200%',
			})

			slideDown([itemsRef.current])
		}
	}, [])

	const slideDown = (arr) => {
		gsap.to(arr, {
			y: '0%',
			stagger: 0.1,
		})
	}

	//! Checkers
	const fontSize = useMemo(() => (type === 'burger' ? 'h4' : type === 'footer' ? 'h8' : 'h9'), [type])
	const fontFamily = useMemo(() => (type === 'footer' ? 'terminaBold' : 'maisonSemiBold'))
	const isFooter = useMemo(() => (type === 'footer' ? 'animStartPos' : ''))

	const storeHeaderMenuItems = useMemo(() => {
		const routesArr = Object.values(config.routes)

		return routesArr.map(
			(element, index) =>
				element.headerMenu && (
					<CustomLink key={index} url={element.path} className='menuRoutes overflowHidden' onClick={closeBurgerMenu}>
						<Text
							className={`${fontSize} ${isFooter} cream capitalize ${fontFamily} linkInnerText ${
								element.path === router.pathname && type !== 'footer' ? 'active' : ''
							}`}
							text={element.name}
							ref={(element) => (itemsRef.current[index] = element)}
						/>
					</CustomLink>
				)
		)
	}, [router.pathname])

	return (
		<AnimationWrap state={secObj} startAnimeArr={startAnimeArr} dependency={router.asPath}>
			<MenuItemsStyle ref={items} type={type} className={className || ''}>
				{storeHeaderMenuItems}
			</MenuItemsStyle>
		</AnimationWrap>
	)
}

export default withUIContext(MenuItems, ['closeBurgerMenu', 'winWidth'])
